import { Component, OnInit, Input } from '@angular/core';
import { SessionsWeek, SessionsWeeksService } from '../../session-weeks.service';
import { camps } from '../../../../models/models.generated';

@Component({
    selector: 'app-refunded-sessions',
    templateUrl: './refunded-sessions.component.html',
    styleUrls: ['./refunded-sessions.component.scss'],
    standalone: false
})
export class RefundedSessionsComponent implements OnInit {

    @Input()
    public purchase: camps.CampPurchaseDetails;

    public weeks: SessionsWeek[];

    constructor(private weekService: SessionsWeeksService) { }

    ngOnInit() {
        this.weeks = this.weekService.createSessionWeeks(this.purchase.refundedSessions);
    }

    public hasRefundedSessions(){
        return this.purchase.refundedSessions && this.purchase.refundedSessions.length > 0;
    }

}
